// extracted by mini-css-extract-plugin
module.exports = {"companyHeader":"Courses_companyHeader__2LTfT","companyImage":"Courses_companyImage__2iVOE","companyTitle":"Courses_companyTitle__2M4HH"};